import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownloadOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Space, Tag } from "antd";
import { EExtendsMergeStrategy, EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { yieldMainThread } from "@devowl-wp/react-utils";
import { useTranslation } from "../../../../../../others/i18n.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateTagManagerOptInEventName() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ServiceTemplateField.TagManagerOptInEventName,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || prev.tagManagerOptInEventName !== next.tagManagerOptInEventName || prev.identifier !== next.identifier,
            hasFeedback: true,
            children: ({ getFieldValue, setFieldValue, setFields, validateFields })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                const identifier = getFieldValue("identifier");
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ServiceTemplateField.TagManagerOptInEventName,
                    defaultStrategy: EExtendsMergeStrategy.Overwrite,
                    disableStrategies: [
                        EExtendsMergeStrategy.Append,
                        EExtendsMergeStrategy.Keep
                    ],
                    onKeepContent: extended && (extended[ServiceTemplateField.TagManagerOptInEventName] ? /*#__PURE__*/ _jsx(Tag, {
                        color: "grey",
                        children: extended[ServiceTemplateField.TagManagerOptInEventName]
                    }) : t("Not defined")),
                    children: /*#__PURE__*/ _jsxs(Row, {
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                flex: "auto",
                                children: /*#__PURE__*/ _jsxs(Space.Compact, {
                                    block: true,
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Input, {
                                            value: t("Opt-in"),
                                            readOnly: true,
                                            tabIndex: -1,
                                            className: `${process.env.ANTD_PREFIX}-input-compact-label`
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Item, {
                                            name: ServiceTemplateField.TagManagerOptInEventName,
                                            normalize: (value)=>value.trim(),
                                            rules: [
                                                {
                                                    pattern: /^((?!\s).)*$/,
                                                    message: t("It's recommended using opt-in names without white spaces.")
                                                }
                                            ],
                                            noStyle: true,
                                            style: {
                                                margin: 0,
                                                flex: 1,
                                                minWidth: 0
                                            },
                                            children: /*#__PURE__*/ _jsx(Input, {
                                                maxLength: 255
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                flex: "100px",
                                children: /*#__PURE__*/ _jsx(Button, {
                                    icon: /*#__PURE__*/ _jsx(DownloadOutlined, {}),
                                    type: "link",
                                    disabled: identifier === undefined,
                                    onClick: ()=>{
                                        setFieldValue(ServiceTemplateField.TagManagerOptInEventName, `${identifier.replace(/[^a-zA-Z0-9\s-]/g, "").toLowerCase()}-opt-in`);
                                        yieldMainThread().then(()=>{
                                            // @see https://ant.design/components/form#setfieldsvalue-do-not-trigger-onfieldschange-or-onvalueschange
                                            setFields([
                                                {
                                                    name: ServiceTemplateField.TagManagerOptInEventName,
                                                    touched: true
                                                }
                                            ]);
                                            validateFields([
                                                ServiceTemplateField.TagManagerOptInEventName
                                            ]);
                                        });
                                    },
                                    children: t("Generate")
                                })
                            })
                        ]
                    })
                });
            }
        })
    });
}
export { FormFieldServiceTemplateTagManagerOptInEventName };
